import { ReactNode } from 'react'
import { formatAmount } from '~/components/amount'

export const DONOR_COVER_FEES_TOOLTIP =
  'Fees are Kindest platform and Stripe processing fees.'

type Props = {
  fee: number
  isTicketPurchase?: boolean
  children: ReactNode
}

export const DonorCoverFeesLabel = ({ fee, isTicketPurchase = false, children }: Props) => {
  const transactionType = isTicketPurchase ? 'contribution' : 'donation'

  return (
    <>
      {`I want to help offset the cost of processing this ${transactionType}. Add the processing fees (${formatAmount(fee)}) to my `}
      <span className="whitespace-nowrap">
        {`${transactionType}.`}
        {'\u00a0'}
        <span className="relative -top-[0.1em] inline-flex whitespace-normal align-middle">
          {children}
        </span>
      </span>
    </>
  )
}
